import { render } from "./Auctions.vue?vue&type=template&id=9c5aa8ac&scoped=true"
import script from "./Auctions.vue?vue&type=script&lang=js"
export * from "./Auctions.vue?vue&type=script&lang=js"

import "./Auctions.vue?vue&type=style&index=0&id=9c5aa8ac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c5aa8ac"]])

export default __exports__